import { render, staticRenderFns } from "./LoginFromIcon.vue?vue&type=template&id=388eb7cb&scoped=true&"
import script from "./LoginFromIcon.vue?vue&type=script&lang=js&"
export * from "./LoginFromIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoginFromIcon.vue?vue&type=style&index=0&id=388eb7cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388eb7cb",
  null
  
)

export default component.exports